import styled from 'styled-components'
import Select from '@material-ui/core/Select'
import { makePrefix } from '../mui-helper'

const selectPrefix = 'MuiSelect'
const inputPrefix = 'MuiInputBase'

const base = `&${makePrefix(inputPrefix, 'root')}`
const selectRoot = `& ${makePrefix(selectPrefix, 'root')}`

export const SelectWrap = styled(Select)`
  ${base} {
    font-size: 13px;
    background-color: #fff;
    &:hover, &.Mui-focused {
      .MuiOutlinedInput-notchedOutline {
        border-color: rgba(0, 0, 0, 0.1);
      }
    }
  }
  
  & .MuiOutlinedInput-notchedOutline {
    border-color: rgba(0, 0, 0, 0.1);
  }
  
  ${selectRoot} {
    padding: 8px;
  }
`
